import { render, staticRenderFns } from "./OPENVPNUsageForm.vue?vue&type=template&id=ed9f8ccc&"
import script from "./OPENVPNUsageForm.vue?vue&type=script&lang=js&"
export * from "./OPENVPNUsageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports